const discussionOrders = new Map();

const getDiscussionId = (discussion) => {
  if (!discussion || typeof discussion.id !== 'function') return null;

  const id = discussion.id();

  return id === null || id === undefined ? null : String(id);
};

export const registerDiscussionList = (discussions) => {
  if (!Array.isArray(discussions) || !discussions.length) return;

  const seen = new Set();

  const order = discussions.filter((discussion) => {
    const id = getDiscussionId(discussion);

    if (!id || seen.has(id)) return false;

    seen.add(id);
    return true;
  });

  order.forEach((discussion) => {
    discussionOrders.set(getDiscussionId(discussion), order);
  });
};

export const getNextDiscussion = (discussion) => {
  const id = getDiscussionId(discussion);

  if (!id) return null;

  const order = discussionOrders.get(id);

  if (!order) return null;

  const index = order.findIndex((candidate) => getDiscussionId(candidate) === id);

  return index === -1 ? null : order[index + 1] || null;
};
